import { ACTIONS_WB } from '../actions/wb';

export const wb = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_WB.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_WB.CHANGE_PRODUCT: {
      const { product } = action;
      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    case ACTIONS_WB.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }

    default:
      return state;
  }
};
